import axios from "axios";
import { EndPoint } from "./EndPoint";
import { flightConfig } from "../../config/flightConfig";
import { stringify } from "querystring";
import { json } from "stream/consumers";
import { AuthService } from "../auth/AuthService";
const main = EndPoint.MASTER + "/?api=";
export class FlightServices {
  static getFlightList = async (payload: any) => {
    const url = main + EndPoint.FLIGHT_LIST;
    console.log("flightsearch", JSON.stringify(payload));
    try {
      const response = await AuthService.postCryptoRequestWithoutSlash(
        url,
        JSON.stringify(payload)
      );
      console.log("getFlightList", JSON.stringify(response?.data));
      return response;
    } catch (error) {
      console.error("Error fetching getFlightList:", error);
      throw error;
    }
  };

  static getFlightRateAccToDate = async (payload: any) => {
    //they did not manage response
    const url = main + EndPoint.CALENDER_FARE;
    try {
      const response = await AuthService.postCryptoRequestWithoutSlash(
        url, // ✅ Correct proxied path
        JSON.stringify(payload) // ✅ Raw object, no JSON.stringify here
      );
      console.log("getFlightRateAccToDate", JSON.stringify(response?.data));
      return response;
    } catch (error: any) {
      console.error("❌ API Error:", error?.response?.data || error.message);
      throw error;
    }
  };
  static checkAirRePriceRQ = async (payload: any) => {
    const url = main + EndPoint.AIR_RE_PRICE_RQ;
    console.log("checkAirRePriceRQ", JSON.stringify(payload));
    try {
      const response = await AuthService.postCryptoRequestWithoutSlash(
        url,
        JSON.stringify(payload)
      );
      console.log("checkAirRePriceRQ", JSON.stringify(response?.data));
      // Assuming the response data is
      return response; // Return only da ta instead of full response
    } catch (error) {
      console.error("Error fetching checkAirRePriceRQ", error);
      throw error;
    }
  };
  static getAddonServices = async (payload: any) => {
    const url = main + EndPoint.ADD_ON_SERVICES;
    console.log("getAddonServices", JSON.stringify(payload));
    try {
      const response = await AuthService.postCryptoRequestWithoutSlash(
        url,
        JSON.stringify(payload)
      );

      return response;
    } catch (error) {
      console.error("Error fetching getAddonServices:", error);
      throw error;
    }
  };
  static flightBooking = async (payload: any) => {
    const url = main + EndPoint.FLIGHT_BOOKING;
    console.log("Flight Booking Payload....", JSON.stringify(payload));
    try {
      const response = await AuthService.postCryptoRequestWithoutSlash(
        url,
        JSON.stringify(payload)
      );
      console.log("flightBooking", JSON.stringify(response, null, 2));

      return response;
    } catch (error) {
      console.error("Error fetching flightBooking:", error);
      throw error;
    }
  };
  static getBooking = async (payload: any) => {
    const url = main + EndPoint.GET_BOOKING;
    console.log("Flight Booking Payload", JSON.stringify(payload));
    try {
      const response = await AuthService.postCryptoRequestWithoutSlash(
        url,
        JSON.stringify(payload)
      );
      console.log("getBooking", JSON.stringify(response));

      return response;
    } catch (error) {
      console.error("Error fetching getBooking:", error);
      throw error;
    }
  };
}
